<template>
  <span>{{ params.value ? params.value.codigo : '' }}</span>
</template>

<script>
export default {
  name: 'ClassifCellRenderer'
}
</script>



// WEBPACK FOOTER //
// src/views/private/operational/pci/workmaintenance/ClassifCellRenderer.vue